import { createContext, useContext, useState, type ReactNode } from 'react'
import type { Invoice } from '@shared/types/invoices'

export type InvoiceOperationType =
  | 'record-payment'
  | 'send'
  | 'cancel'
  | 'issue-credit-note'

interface InvoiceOperationsContextValue {
  openOperation: (type: InvoiceOperationType, invoice: Invoice) => void
  currentInvoice: Invoice | null
  setCurrentInvoice: (invoice: Invoice | null) => void
}

const InvoiceOperationsContext = createContext<InvoiceOperationsContextValue | null>(null)

export function useInvoiceOperations() {
  return useContext(InvoiceOperationsContext)
}

interface InvoiceOperationsProviderProps {
  children: ReactNode
  onOpenOperation: (type: InvoiceOperationType, invoice: Invoice) => void
}

export function InvoiceOperationsProvider({
  children,
  onOpenOperation,
}: InvoiceOperationsProviderProps) {
  const [currentInvoice, setCurrentInvoice] = useState<Invoice | null>(null)

  return (
    <InvoiceOperationsContext.Provider
      value={{ openOperation: onOpenOperation, currentInvoice, setCurrentInvoice }}
    >
      {children}
    </InvoiceOperationsContext.Provider>
  )
}
